// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"i2-z","subtitle":"j2-z","wrapper":"k2-z","leftArrow":"l2-z","rightArrow":"m2-z"};